import observable from '@riotjs/observable';

export const ALERT_OPEN = 'ALERT_OPEN';
export const ALERT_CLOSE = 'ALERT_CLOSE';
export const ALERT_OK = 'ALERT_OK';
export const model = observable();

export const openAlert = (message) => {
  return new Promise((resolve) => {
    model.one(ALERT_OK, resolve);
    model.trigger(ALERT_OPEN, message);
  });
};

export const closeAlert = () => {
  model.trigger(ALERT_CLOSE);
};